import { render } from "./CrudDemo.vue?vue&type=template&id=7ac2ece3&scoped=true"
import script from "./CrudDemo.vue?vue&type=script&lang=js"
export * from "./CrudDemo.vue?vue&type=script&lang=js"

import "./CrudDemo.vue?vue&type=style&index=0&id=7ac2ece3&scoped=true&lang=scss"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac2ece3"]])

export default __exports__